<template>
  <div class="Comparacao container">
    <h3>Comparador de tabelas</h3>
    <hr />
    <div class="row">
      <div
        class="col-12 col-md-6 text-center"
        v-bind:class="{
                'bg-secondary':!file1, 
                'bg-success': Boolean(file1Headers.length),
                'bg-warning': Boolean(file1 && !file1Headers.length)
                }"
      >
        <b-form-group label="Arquivo 1 (xls, xlsx ou csv)">
          <b-file
            name="file1"
            v-model="file1"
            v-on:change="parseFile"
            :accept="fileTypes.join(',')"
          />
        </b-form-group>
      </div>
      <div
        class="col-12 col-md-6 text-center"
        v-bind:class="{
                'bg-secondary':!file2, 
                'bg-success': Boolean(file2Headers.length),
                'bg-warning':Boolean(file2 && !file2Headers.length)
                }"
      >
        <b-form-group label="Arquivo 2 (xls, xlsx ou csv)">
          <b-file
            name="file2"
            v-model="file2"
            v-on:change="parseFile"
            :accept="fileTypes.join(',')"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <p>Aquivos importados, agora configure as regras de relacionamento...</p>
        <div class="regras-comparacao">
          <div
            class="regra bg-secondary"
            v-for="(relacionamento,index) in relacionamentoConfig"
            :key="index"
          >
            <div class="row">
              <b-form-group class="col-5 offset-md-1">
                <b-select :options="file1Headers" v-model="relacionamento.file1"></b-select>
              </b-form-group>
              <b-form-group class="col-5">
                <b-select :options="file2Headers" v-model="relacionamento.file2"></b-select>
              </b-form-group>
              <b-button-group class="col-1">
                <b-btn variant="danger" v-on:click="removeRelacionamento(index)">
                  <i class="fa fa-trash"></i>
                </b-btn>
              </b-button-group>
            </div>
          </div>
        </div>
        <b-btn v-on:click="addRelacionamento">+</b-btn>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <p>Regras configuradas, agora selecione quais os campos que deseja comparar...</p>
        <div class="regras-comparacao">
          <div
            class="regra bg-secondary"
            v-for="(comparacao,index) in comparacaoConfig"
            :key="index"
          >
            <div class="row">
              <b-form-group class="col-5 offset-md-1">
                <b-select :options="file1Headers" v-model="comparacao.file1"></b-select>
              </b-form-group>
              <b-form-group class="col-5">
                <b-select :options="file2Headers" v-model="comparacao.file2"></b-select>
              </b-form-group>
              <b-button-group class="col-1">
                <b-btn variant="danger" v-on:click="removeComparacao(index)">
                  <i class="fa fa-trash"></i>
                </b-btn>
              </b-button-group>
            </div>
          </div>
        </div>
        <b-btn v-on:click="addComparacao">+</b-btn>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-12 text-center">
        <b-checkbox v-model="keepAll">Manter todos os campos</b-checkbox>
        <b-btn variant="success" v-on:click="runComparacao">Comparar</b-btn>
      </div>
    </div>
  </div>
</template>

<script>
import fromPairs from "lodash/fromPairs";
import isEqual from "lodash/isEqual";
import mapKeys from "lodash/mapKeys";
import Papa from "papaparse";
import uuid4 from "uuid4";

function download(arr) {
  const csv = Papa.unparse(arr);
  const blob = new Blob([csv], {
    type: "text/csv;charset=utf-8;"
  });

  const filename = uuid4();

  if (window.navigator.msSaveOrOpenBlob)
    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    window.navigator.msSaveBlob(blob, `${filename}.csv`);
  else {
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob, { type: "text/csv" });
    a.download = `${filename}.csv`;
    document.body.appendChild(a);
    a.click(); // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
    document.body.removeChild(a);
  }
}

function comparaValor(a, b) {
  if (!a || !b) {
    return false;
  }

  return isEqual(a.replace(',','.'), b.replace(',','.'));
}

export default {
  data() {
    return {
      fileTypes: [".xls", ".xlsx", ".csv"],
      file1: null,
      file2: null,
      file1Data: [],
      file1Headers: [],
      file2Data: [],
      file2Headers: [],
      relacionamentoConfig: [],
      comparacaoConfig: [],
      keepAll: false
    };
  },
  methods: {
    runComparacao: function(event) {
      const dataMap1 = new Map();
      this.file1Data.forEach(row => {
        const key = fromPairs(
          this.relacionamentoConfig.map((r, idx) => [idx, row[r.file1]])
        );

        const data = this.keepAll
          ? fromPairs(this.file1Headers.map((r, idx) => [r, row[r]]))
          : fromPairs(
              this.comparacaoConfig.map((r, idx) => [idx, row[r.file1]])
            );

        dataMap1.set(key, data);
      });
      const dataMap2 = new Map();
      this.file2Data.forEach(row => {
        const key = fromPairs(
          this.relacionamentoConfig.map((r, idx) => [idx, row[r.file2]])
        );
        const data = this.keepAll
          ? fromPairs(this.file2Headers.map((r, idx) => [r, row[r]]))
          : fromPairs(
              this.comparacaoConfig.map((r, idx) => [idx, row[r.file2]])
            );
        dataMap2.set(key, data);
      });

      const dataMapResult = new Map();
      dataMap1.forEach((v, k) => {
        dataMapResult.set(JSON.stringify(k), { file1: v });
      });
      dataMap2.forEach((v, k) => {
        if (dataMapResult.has(JSON.stringify(k))) {
          dataMapResult.set(
            JSON.stringify(k),
            Object.assign({}, dataMapResult.get(JSON.stringify(k)), {
              file2: v
            })
          );
        } else {
          dataMapResult.set(JSON.stringify(k), { file2: v });
        }
      });

      const dataArrayResult = [];

      dataMapResult.forEach((v, k) => {
        const key = JSON.parse(k);
        const { file1, file2 } = v;

        let row = {};

        this.relacionamentoConfig.forEach((v, idx) => {
          row["file1_" + v.file1] = !!file1 ? key[idx] : "";
          row["file2_" + v.file2] = !!file2 ? key[idx] : "";
        });

        this.comparacaoConfig.forEach((v, idx) => {
          row["file1_" + v.file1] = !!file1 ? file1[idx] : "";
          row["file2_" + v.file2] = !!file2 ? file2[idx] : "";
          row["comparacao_" + v.file1] = comparaValor(
            row["file1_" + v.file1],
            row["file2_" + v.file2]
          );
        });

        if (this.keepAll)
          row = Object.assign(
            {},
            row,
            mapKeys(file1, (v, k) => `file1_${k}`),
            mapKeys(file2, (v, k) => `file2_${k}`)
          );

        const ordered = {};
        Object.keys(row)
          .sort()
          .forEach(k => {
            ordered[k] = row[k];
          });
        dataArrayResult.push(ordered);
      });

      download(dataArrayResult);
    },
    addRelacionamento: function(event) {
      this.relacionamentoConfig.push({ file1: null, file2: null });
    },
    removeRelacionamento: function(index) {
      this.$delete(this.relacionamentoConfig, index);
    },
    addComparacao: function(event) {
      this.comparacaoConfig.push({ file1: null, file2: null });
    },
    removeComparacao: function(index) {
      this.$delete(this.comparacaoConfig, index);
    },
    parseFile: function(event) {
      const file = event.target.files[0];
      const ext = file.name.split(".").pop();
      // Get the "origin" aka "File1" or "File2" to be passed as a param
      // That way I don't need to make 2 distinct functions to parse the file in the same way
      const origin = event.target.name;

      // Clear the settings for the File
      // It have 2 reasons to this
      // 1 - Just to be sure to import the file in a clean environment
      // 2 - Work to signal the user the file is not ready yet
      this.setData([], [], origin);

      switch (ext.toLowerCase()) {
        case "csv":
          // When the file is a CSV, we don't use the XLSX lib which is much slower
          // then the Papaparse lib
          this.parseCsv(file, origin);
          break;
        case "xlsx":
        case "xls":
          this.parseXlsx(file, origin);
          break;
        default:
          break;
      }
    },
    parseCsv: async function(file, origin) {
      // To use "this" inside the callback function
      const self = this;
      // use the ES6 Promise import, that way we can split the code and only send
      // to the client what is really needed

      Papa.parse(file, {
        header: true, // The first line needs to be the header in order to be related with other table
        trimHeaders: true, // Just because we don't like empty spaces... Trim it
        encoding: "ascii", // Imported a bunch of files with this enconding, worked really well to read these pesky abnormal characters
        skipEmptyLines: true,
        complete: function(results) {
          self.setData(results.data, results.meta.fields, origin);
        }
      });
    },
    parseXlsx: async function(file, origin) {
      // To use "this" inside the callback function
      const self = this;

      const XLSX = await import(/* webpackChunkName: "xlsx" */ "xlsx");

      // The XLSX lib don't work with the File from HTML5
      // It needs to be read as an ArrayBuffer and be passed to the lib
      const reader = new FileReader();
      reader.onload = function(e) {
        const data = e.target.result;
        const wb = XLSX.read(data, { type: "array" });
        // Get the first SheetName in the Excel File
        const s0 = wb.SheetNames[0];
        // Transform the First Sheet to JSON (raw as false to always read the fields as strings)
        const json_data = XLSX.utils.sheet_to_json(wb.Sheets[s0], {
          raw: false
        });
        // Object.keys to extract the headers from the data
        self.setData(json_data, Object.keys(json_data[0]), origin);
      };
      // Read the file as an ArrayBuffer and let the "onload" callback do the magic
      reader.readAsArrayBuffer(file);
    },
    setData: function(data, headers, origin) {
      switch (origin) {
        case "file1":
          this.file1Headers = headers;
          this.file1Data = data;
          break;
        case "file2":
          this.file2Headers = headers;
          this.file2Data = data;
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/variables";

.custom-file-label::after {
  content: "Selecionar";
  background-color: $gray-600;
}

.regras-comparacao {
  margin-bottom: 10px;
}
.regra {
  height: 50px;
  line-height: 45px;
  padding-left: 10px;
  padding-right: -10px;
  margin: 0 -15px 0px -15px;
}

.regra .btn-group {
  height: 50px;
  padding: 6px 0 5px 0px;
}
</style>
